<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="top-title">添加村集体</div>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        :inline="true"
        label-width="110px"
        class="form-add"
      >
        <!-- 村集体信息 -->
        <div class="plate">
          <div class="title">
            选择村集体<label>（可从村集体库中匹配已有信息）</label>
          </div>
          <el-form-item label="村集体名称">
            <span style="font-size: 16px; color: #666666">{{
              companyName
            }}</span
            >&nbsp;
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              class="btn-add"
              @click="
                dialogVisible = true;
                handleFilter();
              "
              >点击选择</el-button
            >
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">登录信息</div>
          <el-form-item prop="phone" ref="phone" label="登录手机号">
            <el-input
              placeholder="请输入登录手机号"
              v-model.trim="form.phone"
            ></el-input>
          </el-form-item>
          <el-form-item prop="personName" ref="personName" label="联系人姓名">
            <el-input
              placeholder="请输入联系人姓名"
              v-model.trim="form.personName"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="businessZoneId"
            ref="businessZoneId"
            label="业务区域"
          >
            <el-cascader
              ref="regionCascader"
              :options="businessZoneList"
              :props="zoneProps"
              v-model="checkedZone"
              placeholder="请选择业务区域"
              @change="businessZoneChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item
            prop="businessPersonId"
            ref="businessPersonId"
            label="业务负责人"
          >
            <el-select
              placeholder="请选择业务负责人"
              v-model="form.businessPersonId"
            >
              <el-option
                v-for="(item, index) in dutyPersonList"
                :key="index"
                :label="item.personName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">村集体信息</div>
          <el-form-item prop="provinceId" class="w100" label="所在地区">
            <el-select
              v-model="form.provinceId"
              placeholder="请选择省"
              @change="
                handleChange(form.provinceId, 'cityList', 'provinceName')
              "
              style="width: 200px"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
            <el-select
              v-if="form.provinceId"
              v-model="form.cityId"
              placeholder="请选择市"
              class="city-select"
              @change="handleChange(form.cityId, 'areaList', 'cityName')"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
            <el-select
              v-if="form.cityId"
              v-model="form.areaId"
              placeholder="请选择县"
              class="city-select"
              @change="handleChange(form.areaId, 'countyList', 'areaName')"
            >
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
            <el-select
              v-if="form.areaId"
              v-model="form.townId"
              placeholder="请选择乡镇"
              class="city-select"
              @change="handleChange(form.townId, 'villageList', 'townName')"
            >
              <el-option
                v-for="(item, index) in countyList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
            <el-select
              v-if="form.townId"
              v-model="form.villageId"
              placeholder="请选择村"
              class="city-select"
              @change="handleChange(form.villageId, '', 'villageName')"
            >
              <el-option
                v-for="(item, index) in villageList"
                :key="index"
                :label="item.n"
                :value="item.i"
              >
                {{ item.n }}
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            class="w100"
            prop="fullName"
            ref="fullName"
            label="村集体全称"
          >
            <el-input
              placeholder="请输入村集体全称"
              v-model.trim="form.fullName"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="w100"
            prop="shortName"
            ref="shortName"
            label="村集体简称"
          >
            <el-input
              placeholder="请输入村集体简称"
              v-model.trim="form.shortName"
            ></el-input>
          </el-form-item>
          <el-form-item class="w100" ref="familyNum" label="家庭总数">
            <el-input
              placeholder="请输入家庭总数"
              v-model.trim="form.familyNum"
            ></el-input
            ><span class="unit">户</span>
          </el-form-item>
          <el-form-item class="w100" ref="personNum" label="村民总数">
            <el-input
              placeholder="请输入村民总数"
              v-model.trim="form.personNum"
            ></el-input
            ><span class="unit">人</span>
          </el-form-item>
          <el-form-item class="w100" ref="farmArea" label="耕地面积">
            <el-input
              placeholder="请输入耕地面积"
              v-model.trim="form.farmArea"
            ></el-input
            ><span class="unit">亩</span>
          </el-form-item>
        </div>
        <el-form-item label="">
          <el-button
            class="btn-submit"
            type="primary"
            :disabled="submitFlag"
            @click="handleSubmit()"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="选择村集体" :visible.sync="dialogVisible" width="790px">
      <el-form ref="filterForm" :model="filterForm" :inline="true">
        <el-form-item prop="company">
          <el-input
            v-model.trim="filterForm.company"
            placeholder="村集体名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="legalPerson">
          <el-input
            v-model.trim="filterForm.legalPerson"
            placeholder="负责人"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item> -->
        <el-button type="primary" @click="handleFilter()">查询</el-button>
        <el-button
          type="primary"
          plain
          icon="el-icon-refresh-right"
          @click="handleReset('filterForm')"
          >清空</el-button
        >
        <!-- </el-form-item> -->
      </el-form>
      <el-table :data="tableData" style="width: 100%; margin-top: 10px">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="company"
          label="村集体名称"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="legal_person"
          label="业务负责人"
          min-width="8%"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" min-width="8%" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="selVillageCollect(row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="empty-table">
            <img class="icon-empty" src="@/assets/empty.png" />
            <p>没有查询到该村，<br />可退出当前选择进行信息录入或重新查询。</p>
            <el-button
              type="primary"
              @click="
                handleReset('filterForm');
                dialogVisible = false;
              "
              >退出选择</el-button
            >
          </div>
        </template>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.size"
        :page-count="pagination.pages"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-dialog>
  </el-main>
</template>

<script>
// import regionLibs from "utils/regionLibs";
// let regionData = JSON.parse(JSON.stringify(regionLibs[0].c));
export default {
  name: "VillageManageAdd",
  data() {
    const valiMobilePass = (rule, value, callback) => {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的登录手机号"));
      } else {
        callback();
      }
    };
    return {
      form: {
        companyId: "",
        fullName: "",
        personName: "",
        businessZoneId: "",
        businessPersonId: "",
        shortName: "",
        phone: "",
        provinceId: "",
        provinceName: "",
        cityId: "",
        cityName: "",
        areaId: "",
        areaName: "",
        townId: "",
        townName: "",
        villageId: "",
        villageName: "",
        familyNum: "",
        personNum: "",
        farmArea: "",
      },
      businessZoneList: [],
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [],
      // 选择村集体弹框内搜索数据
      filterForm: {
        company: "",
        legalPerson: "",
        type: 75,
      },
      tableData: [],
      pagination: { page: 1, size: 10, pages: 0 },
      rules: {
        phone: [
          { required: true, message: "请输入登录手机号", trigger: "blur" },
          { validator: valiMobilePass, trigger: "blur" },
        ],
        personName: {
          required: true,
          message: "请输入联系人姓名",
          trigger: "blur",
        },
        businessZoneId: {
          required: true,
          message: "请选择业务区域",
          trigger: "change",
        },
        businessPersonId: {
          required: true,
          message: "请选择业务负责人",
          trigger: "change",
        },
        provinceId: {
          required: true,
          message: "请选择省市县乡镇",
          trigger: "blur",
        },
        villageId: { required: true, message: "请选择村", trigger: "change" },
        fullName: {
          required: true,
          message: "请输入村集体全称",
          trigger: "blur",
        },
        shortName: {
          required: true,
          message: "请输入村集体简称",
          trigger: "blur",
        },
      },
      dialogVisible: false,
      companyName: "", //村集体名称-从弹框选中时有
      submitFlag: false,
      provinceList: [],
      cityList: [],
      areaList: [],
      countyList: [],
      villageList: [],
    };
  },
  watch: {},
  created() {
    this.getBusinessZoneData();
    this.getSelectedCityOptions(1, "provinceList");
  },
  methods: {
    businessZoneChange(newVal) {
      this.form.businessPersonId = "";
      this.form.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.form.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    //村集体数据查询
    handleFilter() {
      this.pagination.page = 1;
      this.getCompanyList();
    },
    //获取列表数据
    getCompanyList() {
      let params = Object.assign({}, this.filterForm, {
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.common.getCompanyList(params).then((res) => {
        this.tableData = res.data.users;
        if (this.pagination.page == 1) this.pagination.pages = res.data.pages;
      });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.handleFilter();
    },
    //选择村集体
    selVillageCollect(row) {
      this.form.companyId = row.id;
      this.form.phone = row.contact_mobile;
      this.form.personName = row.fullname;
      this.companyName = row.company;
      this.dialogVisible = false;
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getVillageList();
    },
    //提交
    handleSubmit(formName) {
      this.submitFlag = true;
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.$http.village
            .addVillage(this.form)
            .then((res) => {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.submitFlag = false;
              this.$router.go(-1);
            })
            .catch((err) => {
              this.submitFlag = false;
            });
        } else {
          for (let i in object) {
            let dom = this.$refs[i];
            console.log(dom);
            if (Object.prototype.toString.call(dom) !== "[object Object]") {
              //这里是针对遍历的情况（多个输入框），取值为数组
              dom = dom[0];
            }
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: "end", //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
          }
          this.submitFlag = false;
          return false;
        }
      });
    },
    /**
     * @description: 选中select后给name赋值同时获取子级数据
     * @Author: yangsibo
     * @Date: 2022-05-09 10:31:13
     * @param {*} pid
     * @param {*} type
     * @param {*} name
     * @return {*}
     */
    handleChange(pid, type, name) {
      let city = {};
      let list = "";
      switch (type) {
        case "cityList":
          this.form.cityId = "";
          this.form.areaId = "";
          this.form.townId = "";
          this.form.villageId = "";
          this.cityList = [];
          this.areaList = [];
          this.countyList = [];
          this.villageList = [];
          list = "provinceList";
          break;
        case "areaList":
          this.form.areaId = "";
          this.form.townId = "";
          this.form.villageId = "";
          this.areaList = [];
          this.countyList = [];
          this.villageList = [];
          list = "cityList";
          break;
        case "countyList":
          this.form.townId = "";
          this.form.villageId = "";
          this.countyList = [];
          this.villageList = [];
          list = "areaList";
          break;
        case "villageList":
          this.form.villageId = "";
          this.villageList = [];
          list = "countyList";
          break;
        case "":
          list = "villageList";
          break;
        default:
          break;
      }
      city = this[list].find((item) => {
        return item.i == pid;
      });
      this.form[name] = city.n;
      type && this.getSelectedCityOptions(pid, type);
    },
    /**
     * @description: 回显省市区的options
     * @Author: yangsibo
     * @Date: 2022-05-09 13:59:44
     * @param {*} provinceId
     * @param {*} cityId
     * @param {*} areaId
     * @param {*} townId
     */
    initOptions(provinceId, cityId, areaId, townId) {
      this.getSelectedCityOptions(provinceId, "cityList", "cityName", cityId);
      this.getSelectedCityOptions(cityId, "areaList", "areaName", areaId);
      this.getSelectedCityOptions(areaId, "countyList", "townName", townId);
      this.getSelectedCityOptions(
        townId,
        "villageList",
        "provinceName",
        provinceId,
        1
      );
    },
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: yangsibo
     * @Date: 2022-05-09 10:16:19
     * @param {string} pid 父级id
     * @param {string} type 赋值省市区数组
     * @param {*} name 省市区Name字段
     * @param {*} id 省市区对应数组
     */
    async getSelectedCityOptions(pid, type, name, id, loading) {
      try {
        let { data } = await this.$http.common.getChildRegion({ pid });
        this[type] = data;
        name && this.initCityName(id, name, data, loading);
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0 !important;
  .top-title {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #e9ebee;
    padding: 0 20px;
    font-size: 20px;
    font-weight: bold;
    color: #018388;
  }
  .plate {
    padding: 10px 20px;
    .title {
      font-size: 18px;
      color: #333333;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      label {
        font-size: 16px;
        color: #999999;
      }
      &:before {
        content: "";
        display: inline-block;
        width: 5px;
        height: 18px;
        background: #018388;
        border-radius: 3px;
        margin-right: 5px;
      }
    }
  }
  .btn-add {
    padding: 9px 7px;
    font-size: 16px;
    border-radius: 3px;
  }
}
.form-add {
  .el-form-item {
    width: 600px;
    .city-select {
      width: 200px !important;
      margin-left: 10px;
    }
    .el-input,
    .el-select,
    .el-cascader {
      width: 360px;
    }
    &.w100 {
      width: 100%;
    }
    &.w50 {
      width: 360px;
    }
    .unit {
      margin-left: 5px;
      color: #606266;
    }
  }
  .btn-submit {
    width: 120px;
    height: 48px;
    background: #018388;
    border-radius: 4px;
    font-size: 18px;
    margin-left: 130px;
  }
}
::v-deep .el-dialog {
  max-height: 80vh;
  overflow-y: auto;
  .el-form {
    .el-input {
      width: 200px;
    }
    .el-button {
      width: 74px;
      padding: 11px 0;
      text-align: center;
    }
  }
  .el-table {
    margin-top: 0 !important;
  }
}
</style>
